import layout from '@/layout'
// import { _l } from '@/i18n'
const meta = { auth: true, cache: true, head: { back: true } }

export default {
  path: '/technology',
  component: layout,
  meta: {
    funcID: 'F0002',
    PID: 'F00',
  },
  children: ((pre) => [
    {
      path: 'pendingOrder',
      name: `${pre}pendingOrder`,
      meta: {
        ...meta,
        head: { back: false },
        title: '待处理生产订单',
        funcID: 'F000201',
        PID: 'F00',
      },
      component: () => import('@/views/factory/technology/pendingOrder'),
    },
    {
      path: 'pendingOrder/:orderCode/:orderNo?',
      name: `${pre}pendingOrder-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { orderNo = '' } = $route.params
          return orderNo || '待处理生产订单'
        },
        funcID: 'F000201',
        PID: 'F00',
      },
      component: () => import('@/views/factory/technology/pendingOrder/detail'),
    },
    {
      path: 'processSheet',
      name: `${pre}processSheet`,
      meta: {
        ...meta,
        head: { back: false },
        title: '工艺单管理',
        funcID: 'F000202',
        PID: 'F00',
      },
      component: () => import('@/views/factory/technology/processSheet'),
    },
    {
      path: 'processSheet/:pageType/:techCode?',
      name: `${pre}processSheet-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { techNo = '' } = $route.query || {}
          return techNo || '工艺单维护'
        },
        funcID: 'F000202',
        PID: 'F00',
      },
      component: () => import('@/views/factory/technology/processSheet/detail'),
      beforeEnter: (to, from, next) => {
        const {
          orderCode = '',
          orderGoodsSpecCode = '',
          pageType = '',
        } = to.params

        if (pageType === 'add') {
          if (!orderCode || !orderGoodsSpecCode) {
            const { name = '' } = from
            if (name) {
              next({ name, replace: true })
              return
            }
            next({ name: 'technology-processSheet', replace: true })
            return
          }
        }
        next()
      },
    },
    {
      path: 'techGoodsCutting',
      name: `${pre}techGoodsCutting`,
      meta: {
        ...meta,
        head: { back: false },
        title: '开料单管理',
        funcID: 'F000202',
        PID: 'F00',
      },
      component: () => import('@/views/factory/technology/techGoodsCutting'),
    },
    {
      path: 'techGoodsCutting/:pageType/:code?',
      name: `${pre}techGoodsCutting-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { techNo = '' } = $route.query || {}
          return techNo || '开料单维护'
        },
        funcID: 'F000203',
        PID: 'F00',
      },
      component: () =>
        import('@/views/factory/technology/techGoodsCutting/detail'),
    },
    {
      path: 'processDictionary',
      name: `${pre}processDictionary`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'F000204',
        PID: 'F00',
      },
      component: () => import('@/views/factory/technology/processDictionary'),
    },
    {
      path: 'processDictionary/:pageType/:pdProcessDictCode?',
      name: `${pre}processDictionary-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { pdProcessDictNo = '' } = $route.query || {}
          return `产品分类工序字典 | ${pdProcessDictNo || 'New'}`
        },
        funcID: 'F000204',
        PID: 'F00',
      },
      component: () => import('@/views/factory/technology/processDictionary/detail'),
    },
    {
      path: 'processTechnical',
      name: `${pre}processTechnical`,
      meta: {
        ...meta,
        head: { back: false },
        title: '工序工艺字典',
        funcID: 'F000205',
        PID: 'F00',
      },
      component: () => import('@/views/factory/technology/processTechnical'),
    }
  ])('technology-'),
}
